import { getLanguageDefaultFonts } from "../sidebar/tabs/subtitle/utils";

export interface FontProperties {
  font_family: string;
  font_weight: string;
  font_size?: number;
  source?: string;
  fill_color?: string;
}

const getOrganizationDefaultFonts = (organization: string, isSubtitle = false, language = ""): FontProperties | {} => {
  switch (organization) {
    case "Comcast":
      return isSubtitle ? {
        font_family: "Comcast New Vision Bold",
        font_weight: "700"
      } : {
        font_family: "Comcast New Vision Regular",
        font_weight: "400"
      };
    case "Verizon":
      return {
        font_family: "Verizon NHG DS",
        font_weight: "700"
      };
    case "Microsoft":
      if (language === "ja") {
        return {
          font_family: "Yu Gothic UI Semibold",
          font_weight: "600",
          font_size: 40
        };
      }
      if (language === "zh-CN") {
        return {
          font_family: "Microsoft Yahei",
          font_weight: "400",
          font_size: 40
        };
      }
      if (language === "zh-TW") {
        return {
          font_family: "Microsoft JhengHei",
          font_weight: "400",
          font_size: 40
        };
      }
      return {
        font_family: "Segoe Sans Display Semibold",
        font_weight: "600",
        font_size: 40
      };
    case "Intellia Therapeutics":
      return {
        font_family: "Poppins",
        font_weight: "400"
      };
    case "Merck":
    case "MSD":
      return {
        font_family: "Invention App Regular",
        font_weight: "400"
      };
    case "Intuitive":
      return {
        font_family: "Brown Regular",
        font_weight: "400"
      };
    case "Zendesk":
    case "Zendesk Working Space":
      return {
        font_family: "FeatureText-Regular-Web",
        font_weight: "400"
      };
    case "Santander":
    case "Santander Private Space":
      return {
        font_family: "Santander Text Regular",
        font_weight: "400"
      };
    case "Premise Health":
      return {
        font_family: "Helvetica Neue",
        font_weight: "700"
      };
    case "Synopsys":
    case "Synopsys Private Workspace":
      return {
        font_family: "Roboto",
        font_weight: "400"
      };
    case "International Rescue Committee":
      return isSubtitle ? {
        font_family: "Akzidenz-Grotesk Std Regular",
        font_weight: "400"
      } : {
        font_family: "Akzidenz-Grotesk Std Bold",
        font_weight: "700"
      };
    case "RTX":
      return {
        font_family: "Arial",
        font_weight: "400"
      };
    case "Target":
      return {
        font_family: "HelveticaForTarget",
        font_weight: "400"
      };
    case "Progressive":
      return {
        font_family: "96Sans",
        font_weight: "400"
      };
    default:
      return getLanguageDefaultFonts(language);
  }
};

export default getOrganizationDefaultFonts;
